

<div class="filter">
  <div class="action-area">
    <button class="btn btn-sm btn-outline-primary me-2" (click)="filterController.selectNone(filter.filters)">{{'filters.select_none' | translate}}</button>
    <button class="btn btn-sm btn-outline-primary" (click)="filterController.selectAll(filter.filters)">{{'filters.select_all' | translate}}</button>
  </div>
  <hr>
    @for (f of filter.filters; track f) {
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [(ngModel)]="f.checked" (ngModelChange)="filterController.filter()">
        <!-- Normal item -->
        @if (f.text && !f.text.includes('filters.') && !f.text.includes('research_grade')) {
          <label class="form-check-label" for="flexCheckChecked">
            {{f.text}}
          </label>
        }
        @if (f.text && f.text.includes('research_grade')) {
          <label class="form-check-label" for="flexCheckChecked">
            <research-grade [grade]="f.id!"></research-grade>
          </label>
        }
        <!-- Empty item -->
        <!--    <label *ngIf="!f.text" class="form-check-label no-data" for="flexCheckChecked">
        {{'filters.no_data' | translate}}
      </label> -->
      <!-- User data custom items-->
      @if (f.text && f.text.includes('filters.') || !f.text) {
        <label class="form-check-label {{f.text == 'filters.no_data' ? 'no-data' : ''}}" for="flexCheckChecked">
          {{f.text | translate}}
        </label>
      }
    </div>
  }
</div>